import React from "react";
import moment from "moment";
import HandReplayer from "./HandReplayer.js";
import ReplayHand from "./ReplayHand.js";
import i18next from "i18next";
import { createVirtualPageLoad, closeVirtualPage } from '../../common/commonService.js'
class PopUpHandReplayer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gameType: "",
      gameNumber: "",
      accountName: "",
      time: "",
      reportGameDate: "",
      handDtls: {},
    };
  }
  componentWillUnmount() {
    closeVirtualPage()
}
componentDidMount() {
   createVirtualPageLoad("/PopUpHandReplayer")
    console.log("===========PopUpHandReplayer==========");
    this.setState({
      handDtls: JSON.parse(localStorage.getItem("handDtls")),
      gameType: localStorage.getItem("handDtls")?'Spin':this.props.match.params.gameType,
      gameNumber: this.props.match.params.gameNumber,
      accountName: this.props.match.params.accountName,
      time: this.props.match.params.time
    },()=>{
      localStorage.setItem('fromClient',true);
      localStorage.removeItem("handDtls");
    });
  }

  render() {
    let nav = typeof navigator !== "undefined" ? navigator : null;
    let fullVersion = 0;
    if (nav) {
      if (nav.appVersion.includes("Mac")) {
        if (nav.appVersion.includes("Mobile")) {
          let osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nav.appVersion);
          fullVersion = parseFloat(
            osVersion[1] + "." + osVersion[2] + osVersion[3]
          );
          if (fullVersion > 12.1) {
            fullVersion = 13;
          } else {
            fullVersion = 12;
          }
        } else {
          let osVersion = /OS X (\d+)_(\d+)_?(\d+)?/.exec(nav.appVersion);
          if(osVersion !=null) {
            fullVersion = parseFloat(osVersion[1] + "." + osVersion[2]);
            if (fullVersion > 10.13) {
              fullVersion = 13;
            } else {
              fullVersion = 12;
            }
          }
          else {
            fullVersion = 13;
          }
        }
      } else {
        fullVersion = 13;
      }
    }

    return (
      <div 
      style={{
        top: 0,
        left: 0,
        zIndex: 20000,
        width: "100%",
        height: "100%",
        overflow: "auto",
        position: "fixed",
        backgroundColor: "#2c2c34"
      }}>
        <style>{"\
        html{\
          width:100% !important;\
        }\
        body{\
          height:100vh !important;\
        }\
      "}</style>
        {this.state.gameType &&
          this.state.gameNumber &&
          this.state.accountName &&
          this.state.time ? (
            <div
              style={{
                top: 0,
                left: 0,
                zIndex: 20000,
                width: "100%",
                height: "100%",
                overflow: "auto",
                position: "fixed",
                backgroundColor: "#2c2c34"
              }}
            >
              {fullVersion && parseFloat(fullVersion) < 13 ? (
                <HandReplayer
                  replayerScreen={"mobile"}
                  handDtls={this.state.handDtls}
                  gameTypeForTitle={this.state.gameType}
                  onClose={() => window.close()}
                  loginStatus={true}
                  gameNo={this.state.gameNumber}
                  accountName={this.state.accountName}
                  partitionDate={this.state.time}
                  gameType={this.state.gameType}
                />
              ) : (
                  <ReplayHand
                    replayerScreen={"desktop"}
                    handDtls={this.state.handDtls}
                    gameTypeForTitle={this.state.gameType}
                    onClose={() => window.close()}
                    loginStatus={true}
                    gameNo={this.state.gameNumber}
                    accountName={this.state.accountName}
                    partitionDate={this.state.time}
                    gameType={this.state.gameType}
                  />
                )}
            </div>
          ) : (
            <div>{i18next.t("lable.NoDataFoundForReplay")}</div>
          )}
      </div>
    );
  }
}

export default PopUpHandReplayer;



/** WEBPACK FOOTER **
 ** ./src/components/HandReplayer/PopUpHandReplayer.js
 **/